import React from 'react';
import type ContactAdministratorPageType from '@jira/admin-pages__contact-administrator/src/ContactAdministratorPage.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyContactAdministratorPage = lazyForPaint<typeof ContactAdministratorPageType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-jira-admin-pages-contact-administrator", jiraSpaEntry: "async-jira-admin-pages-contact-administrator" */ '@jira/admin-pages__contact-administrator/src/ContactAdministratorPage.tsx'
		),
	),
);

const AsyncContactAdministratorPage = (): React.JSX.Element => (
	<LazyPage
		Page={LazyContactAdministratorPage}
		pageId="jira-admin-pages-contact-administrator"
		shouldShowSpinner
	/>
);

export default AsyncContactAdministratorPage;
